import { render, staticRenderFns } from "./Trading.vue?vue&type=template&id=8fbf7d52&scoped=true"
import script from "./Trading.vue?vue&type=script&lang=js"
export * from "./Trading.vue?vue&type=script&lang=js"
import style0 from "./Trading.vue?vue&type=style&index=0&id=8fbf7d52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbf7d52",
  null
  
)

export default component.exports